import {SharedIcon} from "~/react/components/shared/shared-icon";

export function GeneratePaletteButton({ clickHandler }) {
  return (
    <div className="generate-palette-button">
        <button
          type="button"
          className="button grey"
          aria-label="Generate Colour Palette"
          onClick={(e) => clickHandler(e)}
        >
          <SharedIcon iconName="#icon-generate" />
          <span className="">Generate colour palette</span>
        </button>
    </div>
  );
}
